module.exports = __webpack_public_path__ + "img/stop_screen_share.91347bb2.svg";